import { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { selectCSDRowSelectionModel } from 'slices/configuredService/createDraftCSDSlice'

/**
 * Synchronizes the selected priced service from the DataGrid selection into the form and Redux.
 * - Sets `pricedServiceId` form field
 * - Dispatches `setSelectedPricedService`
 * - Auto-calculates price = unit value * quantity when price isn't dirty
 */
export function useCreateDraftServiceSelection({ pricingServices = [], setValue, watch, dirtyFields }) {
  const dispatch = useDispatch()
  const rowSelectionModel = useSelector(selectCSDRowSelectionModel, shallowEqual)
  const quantity = watch?.('quantity')

  useEffect(() => {
    const selId = rowSelectionModel?.[0]
    const isPriceDirty = !!dirtyFields?.price

    if (selId) {
      setValue?.('pricedServiceId', selId, { shouldValidate: true })
      const selectedService = pricingServices.find(service => service.id === selId)
      if (selectedService) {
        setValue?.('selectedPricedService', selectedService)
        const newPrice = (selectedService.value || 0) * (quantity || 0)
        if (!isPriceDirty) {
          // Only auto-calculate price when user hasn't edited it manually
          setValue?.('price', newPrice, { shouldValidate: true, shouldDirty: false })
        }
      }
    } else {
      setValue?.('pricedServiceId', '', { shouldValidate: true })
      // Do not reset price when selection is cleared (e.g., on tab switch); keep user's price intact
    }
  }, [rowSelectionModel, quantity, dirtyFields, pricingServices, dispatch, setValue])
}
